import { render, staticRenderFns } from "./errorstaff.vue?vue&type=template&id=ba6f0062&scoped=true"
import script from "./errorstaff.vue?vue&type=script&lang=js"
export * from "./errorstaff.vue?vue&type=script&lang=js"
import style0 from "./errorstaff.vue?vue&type=style&index=0&id=ba6f0062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f0062",
  null
  
)

export default component.exports